import { useEffect, useMemo, useRef, useState } from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
const ShareModal = ({ open, onClose, reload, currentItem,users }) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const NewUserSchema = Yup.object().shape({
  });
  const defaultValues = useMemo(
    () => ({
 
    }),
    []
  );
  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [ currentItem, reset, defaultValues ]);

  const handleCloseForm = () => {
    reset(defaultValues);
    onClose();
  };

  const onSubmit = handleSubmit(async (data) => {
    console.log('Form data submitted:', data);
    const formData = new FormData();
    users?.forEach(id => formData.append('user_ids[]', id?.id))
    try {
      const response = await postRequest(`${endpoints.accounting.payroll.generate_payroll.assign_share_users}/${currentItem.id}/assign`,
        formData,
        true
      );
      if (response) {
        reset();
        handleCloseForm()
        enqueueSnackbar({
          variant: 'success',
          message: response?.metadata?.message,
        });
      } else {
        handleErrorMessages(response?.metadta?.message ); 
      }
    } catch (err) {
      console.error('Error:', err);
      handleErrorMessages(err.message || 'Submission failed.');
    } finally {
    }
  });
  return (
    <Dialog
      open={ open }
      onClose={ (event, reason) => {
        if (reason !== 'backdropClick') {
          handleCloseForm();
        }
      } }
      fullWidth
      maxWidth="sm"
      sx={ {
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      } }
      transitionDuration={ {
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      } }
    >
      <FormProvider methods={ methods } onSubmit={ onSubmit }>
        <DialogTitle
          sx={ {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          } }
        >
          <span
            className="cardColor"
            style={ { padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' } }
          >
            &nbsp;&nbsp; Share Modal &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={ () => { onClose() } }>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={ {
            borderRadius: '1px',
          } }
        >
          <Box
            mt={ 2 }
            rowGap={ 2 }
            columnGap={ 3 }
            display="grid"
            gridTemplateColumns={ {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(1, 1fr)',
            } }
          >

            <Controller
              name="user_ids"
              control={ control }
              defaultValue={ [] }
              render={ ({ field: { onChange, value }, fieldState: { error } }) => {
                const isAllSelected = value.length === users.length;
                const isIndeterminate = value.length > 0 && value.length < users.length;

                const handleSelectAllClick = () => {
                  if (isAllSelected) {
                    onChange([]);
                  } else {
                    onChange(users.map((emp) => emp.id));
                  }
                };

                return (
                  <FormControl
                    error={ !!error }
                    sx={ { flexShrink: 1, width: { xs: 1, md: 1 } } }
                  >
                    <InputLabel>Users</InputLabel>
                    <Select
                      multiple
                      value={ value }
                      onChange={ (event) => {
                        const { value: selected } = event.target;
                        if (selected[ selected.length - 1 ] === 'all') {
                          if (isAllSelected) {
                            onChange([]);
                          } else {
                            onChange(users.map((emp) => emp.id));
                          }
                        } else {
                          onChange(selected);
                        }
                      } }
                      input={ <OutlinedInput label="Users" /> }
                      renderValue={ (selected) =>
                        users
                          .filter((emp) => selected.includes(emp.id))
                          .map((emp) => emp.first_name + ' ' + emp.last_name)
                          .join(', ')
                      }
                      MenuProps={ { PaperProps: { sx: { maxHeight: 240 } } } }
                    >
                      <MenuItem value="all">
                        <Checkbox checked={ isAllSelected } indeterminate={ isIndeterminate } />
                        Select All
                      </MenuItem>
                      { users?.map((emp) => (
                        <MenuItem key={ emp.id } value={ emp.id }>
                          <Checkbox checked={ value.includes(emp.id) } />
                          { emp?.first_name } { emp?.last_name }
                        </MenuItem>
                      )) }
                    </Select>
                  </FormControl>
                );
              } }
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={ () => {handleCloseForm() } }>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={ isSubmitting }
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default ShareModal;